// extracted by mini-css-extract-plugin
module.exports = {"container":"O5LGO6","content":"e_yDNg","sectionTitle":"_3PABeG","link":"_2wr785","shine-lines":"LVBH9J"};